import {
  afterNextRender,
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef, inject,
  Inject,
  LOCALE_ID,
  NgZone, OnChanges,
  OnDestroy, PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import { EventListEmbeddedStore } from "./event-list-embedded.store";
import { EventType } from "../../../../shared/graphql/generated/graphql";
import { EventsWrapperComponent } from "../../components/events-wrapper/events-wrapper.component";
import { AsyncPipe, DOCUMENT, isPlatformBrowser } from "@angular/common";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Params } from "@angular/router";
import { Subscription } from "rxjs";
import { platform } from "node:os";
import {
  EmbeddedComponentBaseComponent
} from "../../../../shared/components/embedded-component-base/embedded-component-base.component";
import { Event } from "../../../../shared/graphql/generated/graphql";
import { parseSportIdsParam } from "../../../../shared/utils/sport.utils";

@Component({
  selector: 'cs-event-list-embedded',
  standalone: true,
  imports: [
    EventsWrapperComponent,
    AsyncPipe
  ],
  host: {ngSkipHydration: 'true'},
  templateUrl: './event-list-embedded.component.html',
  styleUrl: './event-list-embedded.component.scss',
  providers: [EventListEmbeddedStore]
})
export class EventListEmbeddedComponent extends EmbeddedComponentBaseComponent {
  hostId?: string;
  clubId?: string;
  allEventTypes: EventType[] = [EventType.KnockOutTournament, EventType.RoundRobinTournament, EventType.AmericanoTournament, EventType.Americano, EventType.OpenPlay, EventType.Training, EventType.Other, EventType.League, EventType.LevelingSession, EventType.Tournament];
  eventTypes: EventType[] = [...this.allEventTypes];
  /** Sports the embedding restricts the list to, empty when it does not restrict anything. */
  sportIds: number[] = [];
  take = 100;

  public readonly eventListEmbeddedStore = inject(EventListEmbeddedStore);

  override afterNextRender() {
    this.eventListEmbeddedStore.state$.subscribe(state => {
      setTimeout(() => this.updateHeight(), 100);
    });
  }

  onEventClick(event: Event) {
    const url = event.externalUrl ? event.externalUrl : `${environment.appUrl}/event/${event.id}`;
    console.log('url', url);
    const newWindow = window.open(url, '_blank'); // Open a new window
    if (newWindow) {
      setTimeout(() => {
        newWindow.location.href = url;
      }, 100); // Set the URL after a short delay
    } else {
      alert('Please allow popups for this website');
    }
  }

  override onQueryParamsChange(params: Params) {
    this.hostId = params['hostId'];
    // merchantId is what the embed configuration calls the club these events belong to
    this.clubId = params['clubId'] ?? params['merchantId'];

    const eventTypesFromUrlStr: string = params['eventTypes'];
    const eventTypesFromUrlConverted = eventTypesFromUrlStr ? eventTypesFromUrlStr.split(',').map((type: string) => this.convertEventTypeStringToEnum(type.trim())) : [];
    const eventTypesFomUrlConvertedFiltered = eventTypesFromUrlConverted.filter((type): type is EventType => type !== null);
    this.eventTypes = eventTypesFomUrlConvertedFiltered.length > 0 ? eventTypesFomUrlConvertedFiltered : this.allEventTypes;

    this.sportIds = parseSportIdsParam(params['sportIds']);

    this.eventListEmbeddedStore.loadEvents({ take: this.take, offset: 0, organizerId: this.hostId, lang: this.locale, eventTypes: this.eventTypes, clubId: this.clubId, sportIds: this.sportIds });
  }

  /**
   * Accepts both the wire format of the enum (`AMERICANO_TOURNAMENT`) and the readable spelling our
   * embedding configuration documents (`AmericanoTournament`), which the embed script normalises but
   * a hand written iframe url may not.
   */
  convertEventTypeStringToEnum(type: string): EventType | null {
    const normalized = type.replace(/[\s_-]/g, '').toLowerCase();
    const eventType = this.allEventTypes.find(eventType => eventType.replace(/_/g, '').toLowerCase() === normalized);

    if (!eventType) {
      console.warn('Unknown event type provided', type);
      return null;
    }

    return eventType;
  }


}
